import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SearchHistoryState {
    history: Record<string, string[]>;
}

const initialState: SearchHistoryState = {
    history: {},
};

export const searchHistorySlice = createSlice({
    name: 'searchHistory',
    initialState,
    reducers: {
        addSearchTerm: (
            state,
            action: PayloadAction<{ name: string; term: string }>,
        ) => {
            const { name, term: rawTerm } = action.payload;
            const term = rawTerm.trim();
            if (!term) return;

            if (Array.isArray(state.history)) {
                state.history = {};
            }

            if (!state.history[name]) {
                state.history[name] = [];
            }

            state.history[name] = state.history[name].filter((t) => t !== term);

            state.history[name].unshift(term);
            if (state.history[name].length > 5) {
                state.history[name].pop();
            }
        },
        removeSearchTerm: (
            state,
            action: PayloadAction<{ name: string; term: string }>,
        ) => {
            const { name, term } = action.payload;
            if (state.history[name]) {
                state.history[name] = state.history[name].filter(
                    (t) => t !== term,
                );
            }
        },
        clearNamespaceHistory: (state, action: PayloadAction<string>) => {
            state.history[action.payload] = [];
        },
    },
});

export const { addSearchTerm, removeSearchTerm, clearNamespaceHistory } =
    searchHistorySlice.actions;
